module.exports = __webpack_public_path__ + "static/media/blockscanModal.68e09413.jpg";